// BlogSection.js - Version avec design épuré (logique inchangée)
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './BlogSection.css';
import { blogAPI } from '../../api';

const BlogSection = () => {
    const [recentBlogs, setRecentBlogs] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchRecentBlogs();
    }, []);

    const fetchRecentBlogs = async () => {
        try {
            setIsLoading(true);
            setError(null);
            
            const response = await blogAPI.getAll(1);
            
            console.log('Blog Section - API Response:', response);
            
            if (response.success && response.data && response.data.data) {
                const latestBlogs = response.data.data.slice(0, 3);
                setRecentBlogs(latestBlogs);
            } else {
                setRecentBlogs([]);
            }
        } catch (error) {
            console.error('Erreur lors du chargement des blogs récents:', error);
            setError(error.message || 'Erreur lors du chargement des articles');
            setRecentBlogs([]);
        } finally {
            setIsLoading(false);
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'Date non spécifiée';
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString('fr-FR', { 
                year: 'numeric', 
                month: 'short', 
                day: 'numeric' 
            });
        } catch (e) {
            return 'Date non spécifiée';
        }
    };

    const truncateText = (text, maxLength = 100) => {
        if (!text) return '';
        if (text.length <= maxLength) return text;
        return text.substring(0, maxLength) + '...';
    };

    const getImageUrl = (blog) => {
        return blog.image_url || blog.image || '/default-blog.jpg';
    };

    const handleImageError = (e, blog) => {
        console.warn('Failed to load blog image:', blog.title);
        e.target.onerror = null;
        
        const svgFallback = `
            <svg width="100%" height="100%" viewBox="0 0 400 300" preserveAspectRatio="xMidYMid meet">
                <rect width="400" height="300" fill="#f8f9fa"/>
                <text x="200" y="140" font-family="Arial, sans-serif" font-size="24" text-anchor="middle" fill="#6c757d">
                    ${blog.category || 'Blog ETEF'}
                </text>
                <text x="200" y="170" font-family="Arial, sans-serif" font-size="16" text-anchor="middle" fill="#adb5bd">
                    ${truncateText(blog.title, 30)}
                </text>
                <circle cx="200" cy="80" r="30" fill="#e9ecef"/>
                <path d="M200 60 L200 100 M180 80 L220 80" stroke="#adb5bd" stroke-width="4"/>
            </svg>
        `;
        
        const encodedSVG = encodeURIComponent(svgFallback);
        e.target.src = `data:image/svg+xml;utf8,${encodedSVG}`;
    };

    if (isLoading) {
        return (
            <section className="recent-blogs-section">
                <div className="recent-blogs-header">
                    <h2 className="recent-blogs-title">Blog ETEF</h2>
                    <p className="recent-blogs-subtitle">Dernières actualités</p>
                </div>
                <div className="recent-blogs-loading">
                    <div className="recent-blogs-spinner"></div>
                    <p>Chargement des articles...</p>
                </div>
            </section>
        );
    }

    if (error) {
        return (
            <section className="recent-blogs-section">
                <div className="recent-blogs-header">
                    <h2 className="recent-blogs-title">Blog ETEF</h2>
                    <p className="recent-blogs-subtitle">Dernières actualités</p>
                </div>
                <div className="recent-blogs-error">
                    <svg width="50" height="50" viewBox="0 0 24 24" fill="#dc3545">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
                    </svg>
                    <p>{error}</p>
                    <button onClick={fetchRecentBlogs} className="recent-blogs-retry-btn">
                        Réessayer
                    </button>
                </div>
            </section>
        );
    }

    if (recentBlogs.length === 0) {
        return (
            <section className="recent-blogs-section">
                <div className="recent-blogs-header">
                    <h2 className="recent-blogs-title">Blog ETEF</h2>
                    <p className="recent-blogs-subtitle">Découvrez nos derniers articles et actualités</p>
                </div>
                <div className="recent-blogs-empty">
                    <svg width="60" height="60" viewBox="0 0 24 24" fill="#6c757d">
                        <path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z"/>
                    </svg>
                    <h3>Aucun article disponible</h3>
                    <p>Revenez bientôt pour découvrir nos nouveaux articles !</p>
                </div>
            </section>
        );
    }

    return (
        <section className="recent-blogs-section">
            <div className="recent-blogs-header">
                <h2 className="recent-blogs-title">Blog ETEF</h2>
                <p className="recent-blogs-subtitle">Découvrez nos derniers articles et actualités</p>
            </div>

            <div className="recent-blogs-grid">
                {recentBlogs.map(blog => (
                    <article key={blog.id} className="recent-blog-card">
                        <Link to={`/blog/${blog.slug || blog.id}`} className="recent-blog-image-link">
                            <div className="recent-blog-image-container">
                                <img 
                                    src={getImageUrl(blog)} 
                                    alt={blog.title}
                                    loading="lazy"
                                    className="recent-blog-image"
                                    onError={(e) => handleImageError(e, blog)}
                                />
                                {blog.category && (
                                    <span className="recent-blog-category">{blog.category}</span>
                                )}
                            </div>
                        </Link>
                        
                        <div className="recent-blog-content">
                            <div className="recent-blog-meta">
                                <span className="recent-blog-date">
                                    <svg className="recent-blog-meta-icon" viewBox="0 0 24 24" width="16" height="16">
                                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
                                    </svg>
                                    {formatDate(blog.published_date || blog.created_at)}
                                </span>
                                {blog.author && (
                                    <span className="recent-blog-author">
                                        <svg className="recent-blog-meta-icon" viewBox="0 0 24 24" width="16" height="16">
                                            <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                                        </svg>
                                        {blog.author}
                                    </span>
                                )}
                            </div>
                            
                            <h3 className="recent-blog-title">
                                <Link to={`/blog/${blog.slug || blog.id}`} className="recent-blog-title-link">
                                    {blog.title}
                                </Link>
                            </h3>
                            
                            <div className="recent-blog-excerpt">
                                {blog.excerpt || truncateText(blog.content, 100)}
                            </div>
                            
                            <div className="recent-blog-actions">
                                <Link 
                                    to={`/blog/${blog.slug || blog.id}`} 
                                    className="recent-blog-read-btn"
                                >
                                    <span>Lire la suite</span>
                                    <svg className="recent-blog-arrow-icon" viewBox="0 0 24 24" width="18" height="18">
                                        <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/>
                                    </svg>
                                </Link>
                            </div>
                        </div>
                    </article>
                ))}
            </div>

            {recentBlogs.length > 0 && (
                <div className="recent-blogs-all-link">
                    <Link to="/blog" className="recent-blogs-all-btn">
                        Voir tous les articles
                        <svg className="recent-blogs-all-arrow" viewBox="0 0 24 24" width="20" height="20">
                            <path d="M8.59 16.59L10 18l6-6-6-6-1.41 1.41L13.17 12z"/>
                        </svg>
                    </Link>
                </div>
            )}
        </section>
    );
};

export default BlogSection;